module.exports = __webpack_public_path__ + "static/media/RecruitmentLogo_white.20c00c38.png";